import { useTranslation } from 'react-i18next';

import { ButtonGroup } from '@pimm/base';
import { useSalesLaborTracker } from '../context/sales-labor-tracker.context';

export const OperationalHoursTab = () => {
  const { t } = useTranslation();
  const partNumber = useSalesLaborTracker(_ => _.partNumber);
  const isOperatingHours = useSalesLaborTracker(_ => _.isOperatingHours);
  const setIsOperatingHours = useSalesLaborTracker(_ => _.setIsOperatingHours);

  if (!!partNumber) return null;
  return (
    <ButtonGroup h="36px" value={isOperatingHours} onChange={setIsOperatingHours} ml={5}>
      <ButtonGroup.Item borderLeftRadius="md" h={7} value={true}>
        {t('sales_tracker:operational_hours')}
      </ButtonGroup.Item>
      <ButtonGroup.Item borderRightRadius="md" h={7} value={false}>
        {t('sales_tracker:twenty_four_hours')}
      </ButtonGroup.Item>
    </ButtonGroup>
  );
};
